import { connect } from 'react-redux';

import { chatFeedActions, chatFeedSelectors, chatFeedOperations } from '../../duck';
import { appActions } from 'App/duck';

import ChatSessionsComponent from './ChatSessionsComponent';

const mapStateToProps = (state) => {
  const { appReducer, chatFeedReducer, locationReducer } = state;
  const { chats, active } = chatFeedReducer;

  return {
    chatList: chatFeedSelectors.getDateOrderedChatFeed(chatFeedReducer),
    active: active.chatSession,
    locations: locationReducer.locations,
    locationId: locationReducer.location_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  const setActiveChatSession = (id) => {
    dispatch(chatFeedActions.updateActiveChatSession(id));
    dispatch(chatFeedActions.updateActivePost({ id: 0, channel_name: '' }));
    dispatch(chatFeedActions.updateActiveDelete({ type: '', id: 0 }));
    dispatch(chatFeedActions.updateActiveSidePane(''));
  };

  const archiveChatSession = (chatSessionId) => {
    dispatch(chatFeedOperations.archiveChatSession(chatSessionId));
  };


  const ResetNotifyNewChatMessage = (channelId) => {
    dispatch(chatFeedActions.ResetNotifyNewChatMessage(channelId));
  };

  return {
    setActiveChatSession,
    archiveChatSession,
    ResetNotifyNewChatMessage,
  };
};

const ChatSessionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatSessionsComponent);

export default ChatSessionsContainer;
